/*
 *
 * PrivacyConsentsModal
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 26-Mar-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { nullSafe } from 'Utility/globalMethods'
import PrivacyConsentsModal from './PrivacyConsentsModal'
import * as PersonalDataActions from '../../modules/PersonalDataActions'
import { doHidePopup } from 'Store/actions/popup'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(PersonalDataActions, dispatch),
  doHidePopup: () => dispatch(doHidePopup())
})

const mapStateToProps = (state) => ({
  userConsents: nullSafe(() => state.PersonalData.userConsents, {}),
  isLoading: nullSafe(() => state.loading.localLoading.update_consents, false)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(PrivacyConsentsModal)
